import dbRepository from "./dbRepository";

function publish(name, detail) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

/**
 * Server-authority write: PUT first, then local cache is updated inside saveTodoList.
 * Resolves `{ ok: true }` only when the mutation was committed.
 * A conflict-merge retry that commits resolves `{ ok: true, merged: true }`
 * (non-delete activity may still log; delete cascade must not treat it as a delete).
 * An unresolved conflict merge resolves `{ ok: false, reason: "conflict", conflict: true }`.
 * A failed PUT whose reload succeeds resolves `{ ok: false, reason: "reload" }`
 * so callers can tell the mutation did not stick. Callers may ignore the promise.
 * Failures still emit sync-write-failed / conflict events. If reload itself fails, the promise rejects.
 */
function update(toDoListId, toDoList) {
  const run = async () => {
    const { requireOnline, saveTodoList } = require("../sync/sessionSync.js");
    requireOnline();
    const result = await saveTodoList(toDoListId, toDoList);
    if (result && result.conflict) {
      return {
        ok: false,
        reason: "conflict",
        conflict: true,
        ...(result.merged ? { merged: true } : {}),
      };
    }
    if (result && result.merged) return { ok: true, merged: true };
    return { ok: true };
  };
  const promise = run().catch((error) => {
    const message =
      (error && error.code === "OFFLINE" && "网络不可用") ||
      (error && error.message) ||
      "同步失败";
    publish("sync-write-failed", { listId: String(toDoListId), message });
    // Best-effort reload from server so Vuex matches authority.
    // Resolve not-ok so activity/cascade callers do not treat rollback as success.
    try {
      const { reloadTodoListFromServer } = require("../sync/sessionSync.js");
      return reloadTodoListFromServer(null, toDoListId).then(
        () => ({ ok: false, reason: "reload" }),
        (reloadError) => Promise.reject(reloadError || error)
      );
    } catch (_) {
      return Promise.reject(error);
    }
  });
  return promise;
}

function remove(toDoListId) {
  // Document delete still goes through IDB; cloud delete via sync engine if queued.
  // Prefer clearing to [] via update() for calendar days.
  let db_req = dbRepository.open();
  db_req.onsuccess = function (event) {
    let db = event.target.result;
    dbRepository.delete(db, "todo_lists", toDoListId);
  };
}

export default {
  update,
  remove,
};
